import jsonapi from 'jsonapi-parse';

export default $axios => ({ store }) => ({
    async getGrammarCheckStatus(fileName) {
        try {
            const response = await $axios.$get(`/rest/document/${fileName}/grammar-check-submission`);
            return response.data.attributes.status;
        } catch (e) {
            return null;
        }
    },
    async download(filename, renameAs, dialect = null) {
        await $axios.get(`/grammar-check/document/${filename}/download`, { responseType: 'blob' })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                let link = document.createElement('a');
                link.href = url;
                if (!renameAs) {
                    renameAs = response.headers['content-disposition'].match(/filename="(.*?)"/i)[1];
                } else {
                    let extension = response.headers['content-disposition'].match(/filename=".*\.(.*?)"/i)[1];
                    renameAs = `${renameAs}${dialect ? `-${dialect}` : ''}.${extension}`;
                }
                link.setAttribute('download', renameAs);
                link.click();
            });
    },

    async getAvailableGrammarCheckDialects(language) {
        const response = await $axios.$get(`/rest/document/grammar-check/${language}/dialects`);
        return jsonapi.parse(response.data);
    },

    async getGrammarCheckDocumentsList(orderId) {
        const response = await $axios.$get(`/rest/document/grammar-check/order/${orderId}`);
        return jsonapi.parse(response.data);
    },

    uploadDocumentForGrammarCheck(orderId, file, dialect) {
        return new Promise((resolve, reject) => {
            let formData = new FormData();
            formData.append('uploadfiletype[file]', file);
            if (dialect) {
                formData.append('dialect', dialect);
            }

            $axios.$post(`/api/v1/plagiarism/grammar-check/order/${orderId}`, formData, {
                ignoreLogout: true,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } })
                .then(({ data }) => {
                    resolve(data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    async requestGrammarReportInChosenDialect(orderId, fileId, dialect) {
        const response = await $axios.post(`/api/v1/plagiarism/grammar-check/order/${orderId}/dialect`, { file_id: fileId, dialect: dialect });
        return jsonapi.parse(response.data);
    },
});
